import * as React from "react"
export const Svg_024 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="M39.401 50.262v-4.893h-3.035l-3.502 4.893H39.4Z"
      />
      <path
        fill="url(#c)"
        d="M35.31 53.719V59h17.573v-4.55c0-5.007-4.074-9.081-9.082-9.081h-.943v8.35H35.31Z"
      />
      <path fill="url(#d)" d="M27.15 53.719h4.703V59H27.15V53.72Z" />
      <path
        fill="url(#e)"
        d="M16.142 53.719v-8.35h-.944c-5.007 0-9.081 4.074-9.081 9.082V59h17.576v-5.282h-7.551Z"
      />
      <path fill="url(#f)" d="m26.137 50.262-3.503-4.893h-3.035v4.893h6.538Z" />
      <path
        fill="url(#g)"
        d="M25.25 38.993v4.093l4.25 5.935 4.25-5.935v-4.093c-1.355.37-2.78.568-4.25.568-1.47 0-2.895-.198-4.25-.568Z"
      />
      <path
        fill="url(#h)"
        d="M24.135 5.294h3.457c0 3.54 2.88 6.421 6.421 6.421h8.154V0H23.255a6.429 6.429 0 0 0-6.422 6.421v5.294h.88c3.541 0 6.422-2.88 6.422-6.421Z"
      />
      <path
        fill="url(#i)"
        d="M25.863 10.87a9.876 9.876 0 0 1-8.15 4.302h-.88v8.265c0 6.985 5.683 12.667 12.667 12.667s12.667-5.682 12.667-12.667v-8.265h-8.154a9.876 9.876 0 0 1-8.15-4.301Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={34.375}
        x2={36.355}
        y1={46.103}
        y2={50.385}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={39.374}
        x2={45.017}
        y1={47.414}
        y2={59.188}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={28.238}
        x2={30.866}
        y1={54.511}
        y2={58.297}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={10.181}
        x2={15.824}
        y1={47.414}
        y2={59.189}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={21.111}
        x2={23.091}
        y1={46.103}
        y2={50.385}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="g"
        x1={27.216}
        x2={32.287}
        y1={40.497}
        y2={47.452}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="h"
        x1={22.692}
        x2={25.979}
        y1={1.757}
        y2={13.262}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="i"
        x1={22.692}
        x2={34.656}
        y1={14.656}
        y2={34.096}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h59v59H0z" />
      </clipPath>
    </defs>
  </svg>
)